import script from "./SystemPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemPrompt.vue?vue&type=script&setup=true&lang=ts"

import "./SystemPrompt.vue?vue&type=style&index=0&id=37c85473&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c85473"]])

export default __exports__